import { useMemo } from "react";
import { useFetchListTeamMembers } from "../containers/merchant-app/hooks/useFetchListTeamMembers";
import { useFetchGetMerchant } from "../containers/merchant-app/hooks/useFetchGetMerchant";
import { fetchMoreDelayed, flattenInfiniteData } from "../containers/merchant-app/helpers/redux-query-helpers";

export function useIsMerchantAdmin(merchantId: string, userId: string) {
    const { data: merchant, isFetching: isFetchingMerchant } = useFetchGetMerchant(merchantId);

    const {
        data: listTeamMembersResponses,
        canFetchMore,
        isFetchingMore,
        isFetching,
        fetchMore,
    } = useFetchListTeamMembers(merchantId, merchant?.meta?.admin_team_id, undefined, {
        enabled: !!merchant?.meta?.admin_team_id,
    });

    useMemo(
        () => fetchMoreDelayed(canFetchMore, isFetchingMore, isFetching, fetchMore),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [canFetchMore, isFetchingMore, isFetching, fetchMore, listTeamMembersResponses]
    );

    const teamMembers = useMemo(
        () => flattenInfiniteData(listTeamMembersResponses, (response) => response.members),
        [listTeamMembersResponses]
    );
    const isMerchantAdmin = useMemo(
        () => userId && teamMembers.some((member) => member.member_user_id === userId),
        [teamMembers, userId]
    );
    const isDetermining = !merchantId || canFetchMore || isFetchingMore || isFetching || isFetchingMerchant;

    return { isMerchantAdmin, isDetermining, merchant, teamMembers };
}
